export default {
  title: '候補者管理',
  registeredList: '自社候補者リスト',
  addEmployee: '候補者登録',
  editEmployee: '候補者編集',
  detailTitle: '候補者詳細',
  addCandidateDialog: {
    addMethod: '登録方法',
    directAdd: '手入力',
    aiParseResume: '履歴書のAI解析',
    uploadResume: '履歴書をアップロード',
    uploadTips: 'ファイル形式は jpg/jpeg/png/webp/doc/xlsx/xls/pdf に限り、1ファイルあたりのサイズは{size}MB以下です。',
    uploadRequired: '履歴書をアップロードしてください',
    startParse: '解析開始'
  },
  selectingCandidates: '全選考リスト',
  selectionDetail: '選考詳細',
  selectingCandidateIng: '全選考リスト',
  detail: {
    ageUnit: '歳',
    workStatus: {
      employed: '在職',
      pending: '入職待ち',
      resigned: '退職済み',
    },
    visaTasks: {
      emptyText: 'まだタスクが作成されていません',
      columns: {
        id: 'タスク番号',
        type: '種類',
        dataCompletion: '書類完成状況',
        status: '書類完成状況',
        creator: '作成者',
        createTime: '作成日時',
        operation: '操作',
      },
      types: {
        change: '変更',
        update: '更新',
        firstApplication: '初回申請',
      },
      statuses: {
        inProgress: '進行中',
        submitted: '開始前',
        applicationSuccess: '完成済み',
        applicationFailed: '取消済み',
      },
      actions: {
        edit: '編集',
        view: '閲覧',
      },
    },
  },
  filters: {
    enterpriseName: '応募企業',
    name: '候補者',
    country: '国籍',
    visaType: '在留資格',
    visaStatus: '在留資格のステータス',
    department: '勤務先',
    employmentType: '雇用形態',
    japaneseLevel: '日本語レベル',
    industry: '業界',
    candidateId: '候補者 ID',
    recentIndustry: '直近業界',
    desiredJobIndustry: '希望業界',
    specialSkillIndustry: '特定技能所有資格',
    specialSkillIndustry1: '特定技能 1 号資格',
    specialSkillIndustry2: '特定技能 2 号資格',
    applicationChannel: '応募チャンネル',
    source: '応募経路',
    registrationDate: '登録日',
    creator: '登録者',
    startDate: '開始',
    endDate: '終了',
    applicationDate: '応募日',
    email: 'メールアドレス',
    status: 'ステータス',
    userType: '分類',
    userNameMeta: 'ユーザー名_Meta',
    placeholder: '入力してください',
    placeholder1: '入力して選択すると追加される',
    placeholderId: '入力してください',
    placeholderSelect: '選択してください',
    moreFilters: '詳細検索',
    search: '検索',
    reset: 'リセット',
  },
  tableStats: '合計: #total# 件、選択: #selected# 件',
  tableStatsWithOutTotal: '選択: #selected# 件',
  tabs: {
    employed: '在職中',
    pending: '入社待ち',
    resigned: '離職済み',
  },
  // 候補者ステータスの選択肢管理
  statusOptions: {
    manage: 'ステータス管理',
    title: 'ステータス管理',
    tip: '引用回数が0より大きい項目は削除できません。　　　',
    add: '追加',
    columnName: '項目',
    columnRefCount: '引用回数',
    columnAction: '操作',
    namePlaceholder: '項目を入力してください',
    nameRequired: '項目を入力してください',
    nameDuplicated: 'この項目は既に存在します',
    close: '閉じる',
  },
  table: {
    candidate: '候補者',
    candidateId: '候補者 ID',
    userNameMeta: 'ユーザー名_Meta',
    aiScore: 'AIスコア',
    basicInfo: '基本情報',
    visaStatus: '在留資格',
    japaneseLevel: '日本語レベル',
    appliedJobCount: '応募求人数',
    recentIndustry: '直近業界',
    desiredJobIndustry: '希望業界',
    specialSkillIndustry: '特定技能所有資格',
    specialSkillIndustry1: '特定技能 1 号資格',
    specialSkillIndustry2: '特定技能 2 号資格',
    applicationChannel: '応募チャンネル',
    source: '応募経路',
    registrationDate: '登録日時',
    creator: '登録者',
    name: '氏名',
    country: '国籍・地域',
    department: '勤務先',
    position: '職務名',
    phone: '電話番号',
    email: 'メールアドレス',
    employmentType: '雇用形態',
    visaStatusLabel: '在留資格のステータス',
    enterpriseName: '応募企業',
    candidateStatus: 'ステータス',
    userType: '分類',
    nextActionDate: '次回行動日',
    remark: 'メモ',
    resumeCompleteness: '情報充足度',
    desiredWorkLocation: '希望勤務地',
    currentTakeHomeSalary: '現職手取り給',
    desiredTakeHomeSalary: '希望手取り給料',
    updateTime: '更新日時',
    updater: '更新者',
    actions: '操作',
    detail: '詳細',
    edit: '編集',
    manageVisa: '在留資格管理',
    delete: '削除',
  },
  columns: {
    nameNickname: '氏名(呼称)',
    candidate: '候補者',
    candidateId: '候補者 ID',
    aiScore: 'AIスコア',
    basicInfo: '基本情報',
    visaStatus: '在留資格',
    japaneseLevel: '日本語レベル',
    appliedJobCount: '応募求人数',
    recentIndustry: '直近業界',
    desiredJobIndustry: '希望業界',
    specialSkillIndustry: '特定技能所有資格',
    source: '応募経路',
    specialSkillIndustry1: '特定技能 1 号資格',
    specialSkillIndustry2: '特定技能 2 号資格',
    applicationChannel: '応募チャンネル',
    registrationDate: '追加時間',
    creator: '追加者',
    country: '国籍・地域',
    department: '勤務先',
    position: '職務名',
    phone: '電話番号',
    email: 'メールアドレス',
    employmentType: '雇用形態',
    residenceCardExpiry: '在留カード有効期限',
    residenceCardPeriod: '在留カード期間',
    daysUntilExpiry: '残り在留期間',
    entryDate: '入社日',
    trialPeriod: '試用期間(月)',
    contractEndDate: '契約満了日',
    status: '在留資格のステータス',
    operations: '操作',
    detail: '詳細',
    edit: '編集',
    manageVisa: '在留資格管理',
    delete: '削除',
    more: 'もっと見る',
    industry: '特定産業分野',
  },
  status: {
    normal: '正常',
    expiredSoon: '期限切れ間近',
    expired: '期限切れ',
    notEntered: '未録入',
  },
  messages: {
    searchSuccess: '検索成功',
    resetSuccess: '検索条件をリセットしました',
    pleaseComplete: '情報を入力してください',
    fetchListFailed: '従業員リストの取得に失敗しました',
  },
  emptyState: {
    noResults: '検索結果がありません',
    tryModifyFilters: '検索条件を変更して再試行してください',
    noEmployees: '従業員がまだ追加されていません',
  },
  period: {
    year: '年',
    month: '月',
    day: '日',
  },
  stats: {
    total: '合計',
    selected: '件、選択',
    items: '件',
  },
  editSteps: {
    employeeInfo: '基本情報',
    residenceInfo: '在留カード/保有資格',
    experience: '学歴/職歴',
    documents: '添付ファイル',
  },
  // 面談情報
  meeting: {
    title: '面談履歴',
    create: '面談作成',
    meetingUrl: '面談URL',
    memo: 'メモ欄',
    copyUrl: '面談URLコピー',
    edit: '面談修正',
    delete: '面談削除',
    online: 'オンライン面談',
    offline: '対面面談',
    meetingTime: '面談日程',
    owner: '担当者',
    deleteContent: '削除後は元に戻せません。以下の面談を削除しますか？',
    timeRequired: '面談時間を選択してください',
    startTimePlaceholder: 'HH:MM',
    endTimePlaceholder: 'HH:MM',
    createConfirm: '作成',
    empty: '面談情報がありません',
    mode: '面談方式',
    aiInterview: 'AI 面談',
    manualInterview: '人工面談',
    aiOnlineInterview: 'AI オンライン面談',
    aiAgent: 'AI Agent',
    cancel: '面談キャンセル',
    cancelTitle: '面談日程キャンセル',
    cancelContent: 'キャンセル後は元に戻せません。以下の面談日程をキャンセルしますか？',
    cancelConfirm: 'キャンセルする',
    viewDetail: '面談詳細を見る',
    agreeApplyJobs: '同意投递职位',
    agreeApplyCount: '同意投递',
    japaneseScore: '日语能力',
    bcScore: 'BC 能力',
    statusPending: '待面谈',
    statusWaitingResult: '待更新面谈结果',
    scheduleUpdater: '日程最終更新者',
    scheduleUpdateTime: '日程最終更新日時',
  },
  // ユーザータグ
  userTag: {
    title: 'ユーザーラベル',
    userType: '分類',
    classificationConfidence: '分類確信度',
    attributesTitle: 'ユーザー属性',
    inflowChannel: '流入チャネル',
    inflowAd: '流入広告',
    inflowDate: '流入日',
    messengerUrl: 'Messenger URL',
    firstInquiryTimeMeta: '初回問い合わせ日_Meta',
    lincFirstReplyTimeMeta: 'Linc 初回返信日_Meta',
    lastInquiryDateMeta: '直近問い合わせ日_Meta',
    lincLastReplyDateMeta: 'Linc 直近返信日_Meta',
    userNameMeta: 'ユーザー名_Meta',
    metaId: 'PSID',
    stagnantDays: '滞留日数',
    metaReachable: 'Meta連絡可否',
    lastContactedDate: '直近連絡成功日',
    lastContactedChannel: '直近連絡成功チャネル',
    actionTiming: 'アクション期日',
    necessityScore: 'N_必然型点数',
    opportunityScore: 'O_機会型点数',
    intentionType: '意向',
    resumeCompleteness: '情報充足度',
  },
  detailTabs: {
    basicInfo: '基本情報',
    residenceInfo: '在留カード/保有資格',
    experience: '学歴/職歴',
    documents: '添付ファイル',
    visaTasks: 'エントリー履歴',
    meeting: '面談情報',
    userTag: 'ラベル',
  },
  form: {
    addDepartment: '応募チャンネル管理',
    basicInfo: {
      title: '基本情報',
      name: '氏名',
      nickname: '呼称',
      nameKana: '氏名(フリガナ)',
      applicationChannel: '応募チャンネル',
      nationality: '国籍・地域',
      birthday: '生年月日',
      gender: '性別',
      genderMale: '男',
      genderFemale: '女',
      hasSpouse: '配偶者の有無',
      hasSpouseYes: '有',
      hasSpouseNo: '無',
      dependents: '扶養家族',
      passportNumber: 'パスポート番号',
      phone: '携帯番号',
      email: 'メールアドレス',
      residenceCardAddress: '在留カード住所',
      nearestStation: '最寄り駅',
    },
    employmentStatus: {
      title: '就業・転職状況',
      employmentStatus: '在職状況',
      desiredJobStartDate: '希望転職時期',
      desiredJobIndustry: '希望業界',
    },
    // 現状調査（エージェント向け・株式会社 Linc のみ）
    currentSurvey: {
      title: '現状ヒアリング',
      incomeSufficiency: '最近の仕事の収入で日常生活を維持できていますか？',
      salaryWorkSatisfaction: '最近のお仕事の給与や働き方に満足していますか？',
      releaseEvent: 'トリガー条件',
      releaseDate: '解除日',
      transferableToSkill2: '2号移行要件への適合',
      note: '補足説明',
    },
    // 求職ニーズ（エージェント向け・株式会社 Linc のみ）
    jobDemand: {
      title: '就職希望',
      earliestStartDate: '最短入社可能日',
      desiredIndustries: '希望業態',
      desiredWorkLocations: '希望勤務地',
      desiredLocationNote: '希望勤務地の補足説明',
      desiredSalary: '希望手取り給料',
      acceptableOvertime: '残業可能な時間',
      nightShiftAcceptable: '夜勤の可否',
      accommodationRequirement: '住居に関するご要望',
      otherRequests: 'その他のご要望',
    },
    // 現職収入（エージェント向け・株式会社 Linc のみ）
    currentIncome: {
      title: '現職収入',
      takeHomePay: '手取り給料',
      takeHomePayNote: '手取り給料の補足説明',
      baseSalary: '基本給',
      bonus: '賞与',
      transportAllowance: '交通手当',
      overtimeAllowance: '残業手当',
      nightShiftAllowance: '夜勤手当',
      housingSituation: '住宅状況',
      housingAllowance: '住宅手当',
      personalRent: '家賃の自分負担額',
      otherAllowances: 'その他の手当て',
    },
    options: {
      yes: 'はい',
      no: 'いいえ',
      has: 'あり',
      hasNot: 'なし',
      acceptable: '可',
      notAcceptable: '不可',
      perHour: '時給',
      perDay: '日給',
      perMonth: '月給',
      perYear: '年俸',
    },
    selfRecommendation: {
      title: '自己 PR・志望動機',
      selfPr: '自己 PR',
      reasonForApplication: '志望動機',
    },
    employmentInfo: {
      title: '雇用情報',
      department: '勤務先',
      position: '職務名',
      employmentType: '雇用形態',
      employmentTypeFull: '正社員',
      employmentTypeContract: '契約社員',
      employmentTypePartTime: 'パート／アルバイト',
      employmentTypeOther: 'その他',
      probationPeriod: '試用期間',
      probationPeriodUnit: '月',
      hireDate: '入社日',
      resignDate: '退職日',
      contractEndDate: '契約満了日',
    },
    validation: {
      nameRequired: '氏名を入力してください',
      nameFormatInvalid: '氏名は半角英字(大文字入力)、スペース区切りで入力してください',
      nameKanaRequired: '氏名(カナ)を入力してください',
      applicationChannelRequired: '応募チャンネルを選択してください',
      nationalityRequired: '国籍・地域を選択してください',
      birthDateRequired: '生年月日を選択してください',
      birthdayRequired: '生年月日を選択してください',
      genderRequired: '性別を選択してください',
      phoneCountryCodeRequired: '国番号を選択してください',
      passportNumberRequired: 'パスポート番号を入力してください',
      phoneRequired: '携帯番号を入力してください',
      phoneInvalid: '正しい携帯番号を入力してください',
      phoneLengthInvalid: '正しい電携帯番号の長さを入力してください',
      phoneFormatInvalid: '有効な電話番号を入力してください',
      emailRequired: 'メールアドレスを入力してください',
      emailInvalid: '正しいメールアドレスを入力してください',
      emailFormatInvalid: '正しいメールアドレスの形式を入力してください',
      residenceCardAddressRequired: '在留カード住所を入力してください',
      employmentStatusRequired: '転職状況を選択してください',
      selfPrRequired: '自己 PRを入力してください',
      reasonForApplicationRequired: '志望動機を入力してください',
      dependentsInvalid: '有効な数字を入力してください',
      dependentsNegative: '負の数を入力することはできません',
      dependentsMax: '50を超えることはできません',
      departmentRequired: '勤務先を選択してください',
      positionRequired: '職務名を入力してください',
      employmentTypeRequired: '雇用形態を選択してください',
      hireDateRequired: '入社日を選択してください',
      responsiblePersonRequired: '担当者を選択してください',
    },
    placeholder: {
      input: '入力してください',
      select: '選択してください',
      date: 'YYYY-MM-DD',
      month: 'YYYY-MM',
      transportAllowance: '例：上限',
      allowanceNote: '固定残業代あり（60,000円/30時間分）超過分は実費支給',
      otherAllowances: '例：食事手当',
    },
    noData: {
      department: 'まず会社管理で勤務先を追加してください',
    },
    residenceInfo: {
      title: '在留カード情報',
      aiParseResidenceCard: '在留カードのAI 解析',
      residenceCardNumber: '在留カード番号',
      residenceStatus: '在留資格',
      industry: '特定産業分野',
      residenceAddress: '住居地',
      employmentRestriction: '就労制限の有無',
      residenceValidityPeriod: '在留期間',
      cardExpiry: '在留期間満了日',
      selectResidenceTypeFirst: '在留資格を先にお選びください',
      isIndefinite: '無期限',
      permitDate: '許可年月日',
      permitType: '許可種類',
      cardIssueDate: '交付年月日',
      cardExpiryDate: '有効期限',
      outsideActivityPermit: '資格外活動許可',
      remainingPeriod: '残期間（特定技能1号）',
      monthUnit: 'ヶ月',
      specificSkills: {
        title: '特定技能',
        qualificationName: '資格名',
        acquisitionMonth: '資格取得月',
        industry: '対象業界',
        certificateNumber: '合格番号',
        remark: '補足説明',
        add: '追加',
        empty: '未入力',
      },
      japaneseLevel: {
        title: '日本語レベル',
        conversationLevel: '会話力',
        qualificationName: '資格名',
        acquisitionMonth: '資格取得月',
        qualificationLevel: '資格等級',
        remark: '補足説明',
        add: '追加',
        empty: '未入力',
      },
      otherLanguages: {
        title: 'その他の言語',
        language: '言語',
        proficiencyLevel: '習熟度',
        additionalNotes: '補足説明',
        add: '追加',
        empty: '未入力',
        notesLabel: '補足説明：',
      },
      qualifications: {
        title: '保有資格',
        qualificationName: '資格名称',
        acquisitionMonth: '資格取得月',
        additionalNotes: '補足説明',
        add: '追加',
        empty: '未入力',
      },
      validation: {
        qualificationNameRequired: '資格名を選択してください',
        acquisitionMonthRequired: '資格取得月を選択してください',
        industryRequired: '業界を選択してください',
        industryFieldRequired: '特定産業分野を選択してください',
        qualificationNameInputRequired: '資格名を入力してください',
        qualificationLevelRequired: '資格等級を選択してください',
        languageRequired: '言語を選択してください',
        proficiencyLevelRequired: '熟練度を選択してください',
      },
    },
    experience: {
      education: {
        title: '学歴',
        schoolName: '学校名',
        schoolLocation: '学校所在地',
        degree: '学歴',
        major: '専攻',
        startDate: '入学年月',
        endDate: '卒業年月',
        graduationStatus: '卒業状況',
        additionalNotes: '補足説明',
        add: '追加',
        empty: '学歴が未登録です',
      },
      work: {
        title: '職歴',
        companyName: '会社名',
        companyLocation: '会社所在地',
        department: '勤務先',
        position: '職種',
        startDate: '入社年月',
        endDate: '退職年月',
        employmentType: '雇用形態',
        employmentTypeFull: '正社員',
        employmentTypeContract: '契約社員',
        employmentTypePartTime: 'パート／アルバイト',
        employmentTypeOther: 'その他',
        reasonForLeaving: '退職理由',
        jobContent: '業務内容',
        add: '追加',
        empty: '職歴が未登録です',
      },
      validation: {
        schoolNameRequired: '学校名を入力してください',
        degreeRequired: '学歴を選択してください',
        majorRequired: '専攻を入力してください',
        startDateRequired: '入学年月を選択してください',
        companyNameRequired: '会社名を入力してください',
        departmentRequired: '勤務先を入力してください',
        positionRequired: '役職名を入力してください',
        workStartDateRequired: '入社年月を選択してください',
        employmentTypeRequired: '雇用形態を選択してください',
        jobContentRequired: '業務内容を入力してください',
        residenceTypeRequired: '在留資格を選択してください',
        industryIdRequired: '特定産業分野を選択してください',
      },
    },
    documents: {
      title: '添付ファイル',
      idPhoto: {
        title: '証明写真',
        tips: '前回の在留カードと同じ写真は使用できません。撮影から6か月以内の写真に限ります。ファイル形式はjpgに限り、サイズは50KB以下であること。帽子なし、正面向き、背景なし、鮮明であることが条件です。サンプル画像あり。',
        exampleLink: 'サンプル画像',
      },
      residenceCard: {
        title: '在留カード',
        titleFront: '在留カードアップロード',
        tips: '在留カードの表面＋裏面の画像をアップロードしてください。ファイル形式は jpg/jpeg/png/webp/pdf に限り、1ファイルあたりのサイズは10MB以下です。',
        tips1: 'ファイル形式は jpg/jpeg/png/webp/pdf に限り、1ファイルあたりのサイズは10MB以下です。',
      },
      passport: {
        title: 'パスポート',
        tips: 'ファイル形式は jpg/jpeg/png/webp/pdf  に限り、1ファイルあたりのサイズは10MB以下です。',
      },
      designation: {
        title: '指定書',
        tips: 'ファイル形式は jpg/jpeg/png/webp/pdf  に限り、1ファイルあたりのサイズは10MB以下です。',
      },
      japaneseCertificate: {
        title: '日本語能力証明書',
        tips: 'ファイル形式は jpg/jpeg/png/webp/pdf  に限り、1ファイルあたりのサイズは10MB以下です。',
      },
      skillCertificate: {
        title: '特定技能評価試験合格証明書',
        tips: 'ファイル形式は jpg/jpeg/png/webp/pdf  に限り、1ファイルあたりのサイズは10MB以下です。',
      },
      resume: {
        title: '履歴書',
        tips: 'ファイル形式は jpg/jpeg/png/webp/docx/doc/xlsx/xls/pdf に限り、1ファイルあたりのサイズは10MB以下です。',
      },
      other: {
        title: 'その他',
        tips: 'ファイル形式は jpg/jpeg/png/webp/docx/doc/xlsx/xls/pdf に限り、1ファイルあたりのサイズは10MB以下です。',
      },
      emptyImage: '未提出',
      emptyFile: '未提出',
    },
  },
};
